import { render, staticRenderFns } from "./ProjectBookAssistant.vue?vue&type=template&id=f9b67540&scoped=true&lang=pug&"
import script from "./ProjectBookAssistant.vue?vue&type=script&lang=ts&"
export * from "./ProjectBookAssistant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b67540",
  null
  
)

export default component.exports